import styled from '@emotion/styled';

export const Wrapper = styled.div`
  /* position: relative; */
  min-height: 300px;
  width: 100%;

  .lk-text-editor {
    width: 100%;
  }

  .lk-text-editor,
  .lk-text-editor .jodit-container {
    min-height: 300px;
  }

  .lk-text-editor .jodit-workplace,
  .lk-text-editor .jodit-wysiwyg {
    min-height: 240px;
  }

  .jodit-container {
    border: 1px solid #d9d9d9;
    /* border-radius: 8px; */
  }
`;
